import HeaderBottom from './HeaderBottom'

export default HeaderBottom
